// app/javascript/packs/collapse.js

export function initCustomCollapse(collapseId, options = {}) {
    const {
      toggleButtonSelector = `[data-toggle-target="${collapseId}"]`,
      cancelButtonSelector = null,
      iconToggle = false,
      iconClasses = { show: 'fa-minus', hide: 'fa-plus' }
    } = options;
  
    function initCollapse() {
      const collapseElement = document.getElementById(collapseId);
      if (!collapseElement) return;
  
      // Ensure it starts hidden
      collapseElement.style.display = 'none';
      collapseElement.classList.remove('show');
  
      // Function to toggle collapse
      function toggleCollapse() {
        const isShown = collapseElement.style.display !== 'none' && collapseElement.style.display !== '';
  
        if (isShown) {
          collapseElement.style.display = 'none';
          collapseElement.classList.remove('show');
        } else {
          collapseElement.style.display = 'block';
          collapseElement.classList.add('show');
        }
  
        // Update icon if iconToggle is enabled
        if (iconToggle) {
          const toggleButton = document.querySelector(toggleButtonSelector);
          if (toggleButton) {
            const iconElement = toggleButton.querySelector('i');
            if (iconElement) {
              if (isShown) {
                iconElement.classList.remove(iconClasses.show);
                iconElement.classList.add(iconClasses.hide);
              } else {
                iconElement.classList.remove(iconClasses.hide);
                iconElement.classList.add(iconClasses.show);
              }
            }
          }
        }
      }
  
      // Handle toggle button click
      const toggleButton = document.querySelector(toggleButtonSelector);
      if (toggleButton) {
        // Remove any existing listeners by cloning
        const newToggleButton = toggleButton.cloneNode(true);
        toggleButton.parentNode.replaceChild(newToggleButton, toggleButton);
  
        newToggleButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          toggleCollapse();
          return false;
        }, true); // Use capture phase
      }
  
      // Handle Cancel button click if provided
      if (cancelButtonSelector) {
        const cancelButton = document.querySelector(cancelButtonSelector);
        if (cancelButton) {
          // Remove any existing listeners by cloning
          const newCancelButton = cancelButton.cloneNode(true);
          cancelButton.parentNode.replaceChild(newCancelButton, cancelButton);
  
          newCancelButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            collapseElement.style.display = 'none';
            collapseElement.classList.remove('show');
  
            // Reset icon if iconToggle is enabled
            if (iconToggle && toggleButton) {
              const iconElement = newToggleButton.querySelector('i');
              if (iconElement) {
                iconElement.classList.remove(iconClasses.show);
                iconElement.classList.add(iconClasses.hide);
              }
            }
            return false;
          }, true); // Use capture phase
        }
      }
    }
  
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCollapse);
    } else {
      initCollapse();
    }
  
    // Also re-initialize on Turbolinks page load if present
    if (typeof Turbolinks !== 'undefined') {
      document.addEventListener('turbolinks:load', initCollapse);
    }
  
    // Handle Turbo (Rails 7) if present
    if (typeof Turbo !== 'undefined') {
      document.addEventListener('turbo:load', initCollapse);
      document.addEventListener('turbo:render', initCollapse);
    }
  }